import { z } from "zod";

/**
 * IndicadorObraSchema
 */

export const IndicadorObraSchema = z.object({
  idIndicadores: z.array(z.number()).nonempty('Este campo deve ser preenchido!'),
  resultado: z.string().nullable().default(null),
});

/**
 * IndicadorObraForm
 */

export type IndicadorObraForm = z.infer<typeof IndicadorObraSchema>;